import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/data-empty.png'
import _imports_1 from '@/assets/img/icon/delete-box-red.svg'
import _imports_2 from '@/assets/img/icon/edit-box-blue.svg'
import _imports_3 from '@/assets/img/modal-confirmation/conductor-save.svg'


const _hoisted_1 = { class: "trayek-form" }
const _hoisted_2 = { class: "flex gap-4" }
const _hoisted_3 = { class: "w-2/3" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  class: "flex items-center justify-center",
  style: {"min-height":"700px"}
}
const _hoisted_6 = { class: "flex flex-col items-center py-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-1/2 lg:w-full mx-auto",
    src: _imports_0
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-bold text-center" }, " Belum ada Bus Terdaftar ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal text-center mb-5 w-full lg:w-1/2" }, " Masih belum ada bus yang terdaftar pada trayek ini. Tambah bus pertamamu dengan klik Tambah Bus di bawah ", -1)
const _hoisted_10 = { class: "text-center w-full lg:w-1/3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, "+ Tambah Bus", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "border-grey-2 rounded-lg p-4" }
const _hoisted_14 = { class: "md:flex items-center justify-between border-bottom-grey-2 pb-5 mb-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Tambah dan Pilih Bus"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal text-grey" }, "Pilih nopol yang tersedia, dan masukkan jam minimal 1 PP. ")
], -1)
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Tambah Bus'), -1)
const _hoisted_18 = { class: "flex items-center mb-3" }
const _hoisted_19 = { class: "w-1/2 lg:w-1/3" }
const _hoisted_20 = {
  key: 1,
  class: "invalid-feedback"
}
const _hoisted_21 = { class: "border-left-grey-2 px-4 ml-4 flex gap-3 items-center" }
const _hoisted_22 = {
  key: 0,
  src: _imports_1,
  alt: "delete",
  class: "cursor-not-allowed",
  style: {"width":"35px","height":"35px"}
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "overflow-x-auto pp-space"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "mb-2" }
const _hoisted_27 = { class: "flex items-center gap-3" }
const _hoisted_28 = { class: "mb-1 font-bold" }
const _hoisted_29 = {
  key: 0,
  src: _imports_1,
  alt: "delete",
  class: "cursor-not-allowed",
  style: {"width":"35px","height":"35px"}
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "text-primary" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Jam Mulai: ")
const _hoisted_33 = { class: "text-primary" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" - Jam Selesai: ")
const _hoisted_35 = { class: "text-primary" }
const _hoisted_36 = { class: "max-w-1/3" }
const _hoisted_37 = {
  key: 0,
  class: "flex justify-end items-center gap-3 mb-1"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Isi Jadwal'), -1)
const _hoisted_39 = {
  key: 1,
  class: "flex justify-end items-center gap-3 mb-1"
}
const _hoisted_40 = { style: {"width":"100px"} }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal" }, "Jam Mulai RIT", -1)
const _hoisted_42 = { class: "text-sm font-normal" }
const _hoisted_43 = { style: {"width":"100px"} }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal" }, "Jam Selesai RIT", -1)
const _hoisted_45 = { class: "text-sm font-normal" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "flex items-center gap-4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Tambah PP'), -1)
const _hoisted_49 = {
  key: 0,
  src: _imports_1,
  alt: "delete",
  class: "cursor-not-allowed",
  style: {"width":"35px","height":"35px"}
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  class: "w-1/3",
  style: {"min-height":"700px"}
}
const _hoisted_52 = {
  key: 0,
  class: "flex items-center justify-center",
  style: {"min-height":"700px"}
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center py-5" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-3/4 lg:w-full mx-auto",
      src: _imports_3
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-bold text-center" }, " Informasi Bus "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal text-center mb-5 w-full lg:w-2/3" }, " Klik tambah dan pilih bus atau klik area pada PP untuk memunculkan informasi bus ")
], -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "mb-5" }
const _hoisted_57 = { class: "text-2xl font-bold" }
const _hoisted_58 = { class: "text-base font-normal text-grey" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal mb-4" }, "Informasi Bus", -1)
const _hoisted_60 = { class: "grid grid-cols-2 gap-4 mb-2" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal text-grey" }, "No Lambung", -1)
const _hoisted_62 = { class: "text-sm font-normal text-right" }
const _hoisted_63 = { class: "grid grid-cols-2 gap-4 mb-2" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal text-grey" }, "No. Polisi", -1)
const _hoisted_65 = { class: "text-sm font-normal text-right" }
const _hoisted_66 = { class: "grid grid-cols-2 gap-4 mb-2" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal text-grey" }, "Tahun Pembuatan", -1)
const _hoisted_68 = { class: "text-sm font-normal text-right" }
const _hoisted_69 = { class: "grid grid-cols-2 gap-4 mb-2" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal text-grey" }, "Type/Karoseri", -1)
const _hoisted_71 = { class: "text-sm font-normal text-right" }
const _hoisted_72 = { class: "grid grid-cols-2 gap-4 mb-2" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal text-grey" }, "Warna", -1)
const _hoisted_74 = { class: "text-sm font-normal text-right" }
const _hoisted_75 = { class: "mt-4" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "node" })
], -1)
const _hoisted_78 = { class: "" }
const _hoisted_79 = { class: "timeline-title text-sm font-normal text-grey" }
const _hoisted_80 = { class: "timeline-desc text-sm font-normal text-grey" }
const _hoisted_81 = { key: 1 }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "node" })
], -1)
const _hoisted_83 = { class: "" }
const _hoisted_84 = { class: "timeline-title text-sm font-normal text-grey" }
const _hoisted_85 = { class: "timeline-desc text-sm font-normal text-grey" }
const _hoisted_86 = { class: "flex items-center justify-end gap-4 mt-4" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Kembali'), -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Selanjutnya'), -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_SelectFetch = _resolveComponent("SelectFetch")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_FieldArray = _resolveComponent("FieldArray")!
  const _component_HjpTabView = _resolveComponent("HjpTabView")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ScheduleForm = _resolveComponent("ScheduleForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_Form, {
            key: 0,
            onSubmit: _ctx.nextPage,
            "validation-schema": _ctx.trayekType === 2 || _ctx.trayekType === 0 ? _ctx.schemaAirport : _ctx.schemaReserve,
            "initial-values": _ctx.initialValue,
            class: "form-container",
            validateOnMount: true
          }, {
            default: _withCtx(({ errors, values, setFieldValue, meta, }) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (!_ctx.isAnyBus)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_Card, { class: "card-no-shadow wrap-hjp-data-list" }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _hoisted_8,
                                _hoisted_9,
                                _createElementVNode("div", _hoisted_10, [
                                  _createVNode(_component_Button, {
                                    class: "w-full extra-submit-button mb-2 sm:mb-0 flex gap-4",
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showForm()))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_11
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_Card, { class: "card-no-shadow wrap-hjp-data-list" }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_FieldArray, { name: "data" }, {
                                default: _withCtx(({ fields, push, remove, prepend }) => [
                                  _createElementVNode("div", _hoisted_14, [
                                    _hoisted_15,
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_Button, {
                                        class: "flex gap-2 extra-submit-button",
                                        outlined: true,
                                        onClick: ($event: any) => (prepend(_ctx.defaultValue))
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", {
                                            innerHTML: _ctx.icon.svg.plusBlueEva
                                          }, null, 8, _hoisted_16),
                                          _hoisted_17
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ])
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (dataX, indexX) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: indexX,
                                      class: _normalizeClass(["rounded-lg p-3 mb-3", (errors['data'] && meta.touched) || (errors[`data[${indexX}].pps`] && meta.touched) ? 'border-danger' : 'border-grey-2'])
                                    }, [
                                      _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("div", _hoisted_19, [
                                          _createVNode(_component_Field, {
                                            id: `data[${indexX}].nopol`,
                                            name: `data[${indexX}].nopol`
                                          }, {
                                            default: _withCtx(({ field }) => [
                                              _createVNode(_component_SelectFetch, _mergeProps(field, {
                                                placeholder: 'Pilih Bus',
                                                modelValue: field.value,
                                                id: `nopol-${indexX}`,
                                                inputId: `bus-${indexX}`,
                                                endpoint: "/management/v1/MsVehicle",
                                                searchCustom: [['activeOnly', '=', true], ['orderByHasTrayek', '=', false]],
                                                selectable: (v) => v.Trayek === null,
                                                fieldLabel: (v) => v.Nopol,
                                                clearable: false,
                                                searchFields: ['nopol'],
                                                classname: 'custom-select',
                                                onChange: ($event: any) => {_ctx.setCurrVehicleInfo(values.data[indexX].nopol); _ctx.changeBus(field, indexX)}
                                              }), null, 16, ["modelValue", "id", "inputId", "selectable", "fieldLabel", "onChange"])
                                            ]),
                                            _: 2
                                          }, 1032, ["id", "name"]),
                                          (meta.touched)
                                            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                                                key: 0,
                                                class: "invalid-feedback",
                                                name: `data[${indexX}].nopol`
                                              }, null, 8, ["name"]))
                                            : _createCommentVNode("", true),
                                          (_ctx.showDuplicateMessage(indexX))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Nopol Sudah Terpakai"))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("div", null, [
                                              (fields.length === 1)
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                                                : (_openBlock(), _createElementBlock("img", {
                                                    key: 1,
                                                    src: _imports_1,
                                                    alt: "delete",
                                                    class: "cursor-pointer",
                                                    style: {"width":"35px","height":"35px"},
                                                    onClick: ($event: any) => {remove(indexX); _ctx.focus(null); fields.length === 0 ? _ctx.isAnyBus = false : _ctx.isAnyBus = true}
                                                  }, null, 8, _hoisted_23))
                                            ])
                                          ])
                                        ])
                                      ]),
                                      (_ctx.trayekType !== 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                            _createVNode(_component_FieldArray, {
                                              name: `data[${indexX}].pps`
                                            }, {
                                              default: _withCtx(({ fields, push, remove, prepend }) => [
                                                (_ctx.trayekType === 2 || _ctx.trayekType === 0)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (data, index) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                          key: data,
                                                          class: "w-full"
                                                        }, [
                                                          (data.value)
                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                key: 0,
                                                                class: _normalizeClass(["rounded-lg p-3 mb-2", errors[`data[${indexX}].pps[${index}]?.departure`] || errors[`data[${indexX}].pps[${index}]?.arrival`] ? 'border-danger' : 'border-grey-2'])
                                                              }, [
                                                                _createElementVNode("div", _hoisted_26, [
                                                                  _createElementVNode("div", _hoisted_27, [
                                                                    _createElementVNode("div", _hoisted_28, _toDisplayString(`PP${index + 1}`), 1),
                                                                    (fields.length === 1)
                                                                      ? (_openBlock(), _createElementBlock("img", _hoisted_29))
                                                                      : (_openBlock(), _createElementBlock("img", {
                                                                          key: 1,
                                                                          src: _imports_1,
                                                                          alt: "delete",
                                                                          class: "cursor-pointer",
                                                                          style: {"width":"35px","height":"35px"},
                                                                          onClick: ($event: any) => {remove(index); _ctx.focus(null)}
                                                                        }, null, 8, _hoisted_30))
                                                                  ]),
                                                                  _createElementVNode("div", _hoisted_31, [
                                                                    _hoisted_32,
                                                                    _createElementVNode("span", _hoisted_33, _toDisplayString(values.data[indexX]?.pps[index]?.details[0]?.departure ? values.data[indexX]?.pps[index]?.details[0]?.departure : values.data[indexX]?.pps[index].departure ?? '--:--'), 1),
                                                                    _hoisted_34,
                                                                    _createElementVNode("span", _hoisted_35, _toDisplayString(values.data[indexX]?.pps[index]?.details[values.data[indexX]?.pps[index]?.details.length - 1]?.arrival ? values.data[indexX]?.pps[index]?.details[values.data[indexX]?.pps[index]?.details.length - 1]?.arrival : values.data[indexX]?.pps[index].arrival ?? '--:--'), 1)
                                                                  ])
                                                                ]),
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.step1Form.rits, (ritData, i) => {
                                                                  return (_openBlock(), _createElementBlock("div", {
                                                                    key: ritData,
                                                                    class: "background-grey-2 rounded-lg py-3 px-3 mb-2 flex items-center justify-between"
                                                                  }, [
                                                                    _createElementVNode("div", _hoisted_36, [
                                                                      _createElementVNode("div", null, _toDisplayString(`Rit ${i+1} : ${ritData.rit.Name}`), 1),
                                                                      (meta.touched)
                                                                        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                                                                            key: 0,
                                                                            class: "invalid-feedback",
                                                                            name: `data[${indexX}].pps[${index}].details[${i}].departure`
                                                                          }, null, 8, ["name"]))
                                                                        : _createCommentVNode("", true)
                                                                    ]),
                                                                    _createElementVNode("div", null, [
                                                                      (!data?.value?.details[i]?.departure && !data?.value?.details[i]?.arrival)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                                            _createVNode(_component_Button, {
                                                                              class: "mb-2 sm:mb-0 flex gap-2",
                                                                              onClick: ($event: any) => (_ctx.showScheduleFormAct(values, data?.value?.details[i], ritData.rit, values.data[indexX].nopol, indexX, index, i))
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _hoisted_38
                                                                              ]),
                                                                              _: 2
                                                                            }, 1032, ["onClick"])
                                                                          ]))
                                                                        : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                                            _createElementVNode("div", _hoisted_40, [
                                                                              _hoisted_41,
                                                                              _createElementVNode("div", _hoisted_42, _toDisplayString(data.value.details[i].departure), 1)
                                                                            ]),
                                                                            _createElementVNode("div", _hoisted_43, [
                                                                              _hoisted_44,
                                                                              _createElementVNode("div", _hoisted_45, _toDisplayString(data.value.details[i].arrival), 1)
                                                                            ]),
                                                                            _createElementVNode("div", null, [
                                                                              _createElementVNode("img", {
                                                                                src: _imports_2,
                                                                                alt: "edit",
                                                                                class: "cursor-pointer mb-2 lg:mb-0",
                                                                                style: {"width":"45px","height":"45px"},
                                                                                onClick: ($event: any) => (_ctx.showScheduleFormAct(values, data.value.details[i], ritData.rit, values.data[indexX].nopol, indexX, index, i))
                                                                              }, null, 8, _hoisted_46)
                                                                            ])
                                                                          ]))
                                                                    ])
                                                                  ]))
                                                                }), 128))
                                                              ], 2))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      }), 128)),
                                                      _createElementVNode("div", _hoisted_47, [
                                                        _createVNode(_component_Button, {
                                                          class: "flex gap-2 extra-submit-button",
                                                          outlined: true,
                                                          onClick: ($event: any) => (push(_ctx.defaultDetailValue))
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_48
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"]),
                                                        _createElementVNode("div", null, [
                                                          (fields.length === 1)
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_49))
                                                            : (_openBlock(), _createElementBlock("img", {
                                                                key: 1,
                                                                src: _imports_1,
                                                                alt: "delete",
                                                                class: "cursor-pointer",
                                                                style: {"width":"35px","height":"35px"},
                                                                onClick: ($event: any) => {remove(fields.length - 1); _ctx.focus(null)}
                                                              }, null, 8, _hoisted_50))
                                                        ])
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1032, ["name"]),
                                            (meta.touched)
                                              ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                                                  key: 0,
                                                  class: "invalid-feedback",
                                                  name: `data[${indexX}].pps`
                                                }, null, 8, ["name"]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 2))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024),
                              (meta.touched)
                                ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                                    key: 0,
                                    class: "invalid-feedback",
                                    name: `data`
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_Card, { class: "card-no-shadow wrap-hjp-data-list trayek-right-panel" }, {
                    content: _withCtx(() => [
                      (!_ctx.selectedBus)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_54))
                        : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.selectedBus.HullNumber ?? '-'), 1),
                              _createElementVNode("div", _hoisted_58, _toDisplayString(`${_ctx.selectedBus.Nopol ?? '-'} (${_ctx.selectedBus.PurchasedAt ??
                    '-'})`), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_59,
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_60, [
                                  _hoisted_61,
                                  _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.selectedBus.HullNumber ?? '-'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_63, [
                                  _hoisted_64,
                                  _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.selectedBus.Nopol ?? '-'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_66, [
                                  _hoisted_67,
                                  _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.selectedBus.PurchasedAt ?? '-'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_69, [
                                  _hoisted_70,
                                  _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.selectedBus.Type ?? '-'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_72, [
                                  _hoisted_73,
                                  _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.selectedBus.Colours ?? '-'), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _createVNode(_component_HjpTabView, {
                                class: "trayek-select-bus",
                                tabHeader: _ctx.tabHeader,
                                onTabsChange: _ctx.tabsChange
                              }, null, 8, ["tabHeader", "onTabsChange"]),
                              _createElementVNode("div", _hoisted_75, [
                                (_ctx.activeTab === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                      _createElementVNode("div", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logBus, (data, index) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: index,
                                            class: "timeline pb-5"
                                          }, [
                                            _hoisted_77,
                                            _createElementVNode("div", _hoisted_78, [
                                              _createElementVNode("div", _hoisted_79, _toDisplayString(`${_ctx.moment(data.CreatedAt.toString()).format('DD MMMM YYYY')} -
                                                        ${_ctx.moment(data.CreatedAt.toString()).format('HH:mm')}`), 1),
                                              _createElementVNode("div", _hoisted_80, _toDisplayString(data.UpdatedString), 1)
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ]))
                                  : (_ctx.activeTab === 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                        _createElementVNode("div", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logTrayek, (data, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: index,
                                              class: "timeline pb-5"
                                            }, [
                                              _hoisted_82,
                                              _createElementVNode("div", _hoisted_83, [
                                                _createElementVNode("div", _hoisted_84, _toDisplayString(`${_ctx.moment(data.CreatedAt.toString()).format('DD MMMM YYYY')} -
                                                        ${_ctx.moment(data.CreatedAt.toString()).format('HH:mm')}`), 1),
                                                _createElementVNode("div", _hoisted_85, _toDisplayString(data.UpdatedString), 1)
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_86, [
                _createVNode(_component_Button, {
                  class: "flex gap-2 extra-submit-button",
                  outlined: true,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.prevPage()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_87
                  ]),
                  _: 1
                }),
                (_ctx.isAnyBus)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "mb-2 sm:mb-0 flex gap-2",
                      type: "submit"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_88
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema", "initial-values"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showScheduleForm)
      ? (_openBlock(), _createBlock(_component_ScheduleForm, {
          key: 0,
          show: _ctx.showScheduleForm,
          ritData: _ctx.selectedRit,
          onHideScheduleForm: _ctx.hideScheduleFormAct,
          onOnSubmit: _ctx.setScheduleValue
        }, null, 8, ["show", "ritData", "onHideScheduleForm", "onOnSubmit"]))
      : _createCommentVNode("", true)
  ], 64))
}